import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/basic',
        name: 'basic-converter',
        meta: {
            version: 'basic'
        },
        component: () => import(/* webpackChunkName: "phonetic" */ '../views/Phonetic.vue')
    },
    {
        path: '/dhusor',
        name: 'dhusor-converter',
        meta: {
            version: 'dhusor'
        },
        component: () => import(/* webpackChunkName: "phonetic" */ '../views/Phonetic.vue')
    },
    {
        path: '/shobdopata',
        name: 'shobdopata-converter',
        meta: {
            version: 'shobdopata'
        },
        component: () => import(/* webpackChunkName: "phonetic" */ '../views/Phonetic.vue')
    },
    {
        path: '/shuvro',
        name: 'shuvro-converter',
        meta: {
            version: 'shuvro'
        },
        component: () => import(/* webpackChunkName: "phonetic" */ '../views/Phonetic.vue')
    },
    {
        path: '/keymap/:version',
        name: 'converter-keymap',
        component: () => import(/* webpackChunkName: "converter-keymap" */ '../views/ConverterKeymap.vue')
    }
];

const router = new VueRouter({
    routes
});

export default router;
